module.exports = require('./_global');


/*****************
 ** WEBPACK FOOTER
 ** /mnt/jenkins/jobs/master/workspace/~/core-js/modules/_path.js
 ** module id = 290
 ** module chunks = 12
 **/